(function() {

    // Alpine.js Carousel Component for Variant Image Swatches
    window.variantCarousel = function() {
      return {
        currentIndex: 0,
        slideCount: 0,
        gap: 8,
        itemWidth: 100,
        itemTotalWidth: 108,
        isDragging: false,
        startX: 0,
        currentTranslate: 0,
        prevTranslate: 0,
        velocity: 0,
        lastMoveTime: 0,
        lastMoveX: 0,
        dragDistance: 0,
        
        init() {
          this.$nextTick(() => {
            this.slides = Array.from(this.$el.querySelectorAll('.mpcarousel__slide'));
            this.slideCount = this.slides.length;
            this.calculateDimensions();
            this.updateCarousel();
            
            // Handle resize
            this.resizeHandler = () => {
              clearTimeout(this.resizeTimeout);
              this.resizeTimeout = setTimeout(() => this.handleResize(), 150);
            };
            window.addEventListener('resize', this.resizeHandler);
          });
        },
        
        destroy() {
          if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler);
          }
        },
        
        calculateDimensions() {
          const styles = getComputedStyle(this.$el);
          this.gap = parseFloat(styles.getPropertyValue('--swatch-gap')) || 8;
          
          if (this.slides && this.slides.length > 0) {
            const firstSlide = this.slides[0];
            const slideStyles = getComputedStyle(firstSlide);
            this.itemWidth = parseFloat(slideStyles.width) || 100;
          }
          
          this.itemTotalWidth = this.itemWidth + this.gap;
        },
        
        getPerPage() {
          const styles = getComputedStyle(this.$el);
          return parseInt(styles.getPropertyValue('--swatch-per-page')) || 4;
        },
        
        needsScrolling() {
          return this.slideCount > this.getPerPage();
        },
      
        handleTouchStart(e) {
          if (!this.needsScrolling()) return;
          
          const touch = e.touches[0];
          this.isDragging = true;
          this.startX = touch.clientX;
          this.lastMoveX = this.startX;
          this.lastMoveTime = performance.now();
          this.velocity = 0;
          this.dragDistance = 0;
          
          this.prevTranslate = -this.currentIndex * this.itemTotalWidth;
          this.currentTranslate = this.prevTranslate;
          
          this.track.setAttribute('dragging', 'true');
          this.list.style.transition = 'none';
        },
        
        handleTouchMove(e) {
          if (!this.isDragging) return;
          if (!this.needsScrolling()) return;
          
          const touch = e.touches[0];
          const currentX = touch.clientX;
          const diff = currentX - this.startX;
          this.currentTranslate = this.prevTranslate + diff;
          
          // Clamp within boundaries
          const perPage = this.getPerPage();
          const maxIndex = Math.max(0, this.slideCount - perPage);
          const minTranslate = -maxIndex * this.itemTotalWidth;
          const maxTranslate = 0;
          this.currentTranslate = Math.max(minTranslate, Math.min(maxTranslate, this.currentTranslate));
          
          // Track velocity
          const now = performance.now();
          const timeDelta = now - this.lastMoveTime;
          if (timeDelta > 0) {
            this.velocity = (currentX - this.lastMoveX) / timeDelta;
          }
          this.lastMoveX = currentX;
          this.lastMoveTime = now;
          
          this.dragDistance = Math.abs(diff);
          
          // Prevent default if actually dragging
          if (this.dragDistance > 5) {
            e.preventDefault();
            e.stopPropagation();
            this.list.style.transform = `translateX(${this.currentTranslate}px)`;
          }
        },
        
        handlePointerDown(e) {
          // Don't initiate drag if all items fit
          if (!this.needsScrolling()) return;
          
          this.isDragging = true;
          this.startX = e.clientX;
          this.lastMoveX = e.clientX;
          this.lastMoveTime = performance.now();
          this.velocity = 0;
          this.dragDistance = 0;
          
          this.prevTranslate = -this.currentIndex * this.itemTotalWidth;
          this.currentTranslate = this.prevTranslate;
          
          this.track.setAttribute('dragging', 'true');
          this.list.style.transition = 'none';
        },
        
        handlePointerMove(e) {
          if (!this.isDragging) return;
          if (!this.needsScrolling()) return;
          
          const currentX = e.clientX;
          const diff = currentX - this.startX;
          this.currentTranslate = this.prevTranslate + diff;
          
          // Clamp within boundaries
          const perPage = this.getPerPage();
          const maxIndex = Math.max(0, this.slideCount - perPage);
          const minTranslate = -maxIndex * this.itemTotalWidth;
          const maxTranslate = 0;
          this.currentTranslate = Math.max(minTranslate, Math.min(maxTranslate, this.currentTranslate));
          
          // Track velocity
          const now = performance.now();
          const timeDelta = now - this.lastMoveTime;
          if (timeDelta > 0) {
            this.velocity = (currentX - this.lastMoveX) / timeDelta;
          }
          this.lastMoveX = currentX;
          this.lastMoveTime = now;
          
          this.dragDistance = Math.abs(diff);
          
          // Prevent default and update if actually dragging
          if (this.dragDistance > 5) {
            e.preventDefault();
            e.stopPropagation();
            this.list.style.transform = `translateX(${this.currentTranslate}px)`;
          }
        },
        
        handlePointerUp(e) {
          if (!this.isDragging) return;
          
          this.isDragging = false;
          this.track.removeAttribute('dragging');
          this.list.style.transition = 'transform 0.3s ease';
          
          // If barely moved, treat as click (don't change position)
          if (this.dragDistance < 10) {
            this.updateCarousel();
            setTimeout(() => {
              this.dragDistance = 0;
            }, 50);
            return;
          }
          
          const movedBy = this.currentTranslate - this.prevTranslate;
          const threshold = this.itemTotalWidth * 0.3;
          const velocityThreshold = 0.5;
          
          let newIndex = this.currentIndex;
          const perPage = this.getPerPage();
          const maxIndex = Math.max(0, this.slideCount - perPage);
          
          if (Math.abs(movedBy) > threshold || Math.abs(this.velocity) > velocityThreshold) {
            if (movedBy < 0 || this.velocity < -velocityThreshold) {
              newIndex = Math.min(this.currentIndex + 1, maxIndex);
            } else if (movedBy > 0 || this.velocity > velocityThreshold) {
              newIndex = Math.max(this.currentIndex - 1, 0);
            }
          }
          
          this.currentIndex = newIndex;
          this.updateCarousel();
          
          setTimeout(() => {
            this.dragDistance = 0;
          }, 300);
        },
        
        updateCarousel() {
          const perPage = this.getPerPage();
          
          // If all slides fit on screen, reset to 0 and don't scroll
          if (this.slideCount <= perPage) {
            this.currentIndex = 0;
            this.list.style.transform = 'translateX(0px)';
            return;
          }
          
          const maxIndex = Math.max(0, this.slideCount - perPage);
          if (this.currentIndex > maxIndex) this.currentIndex = maxIndex;
          
          const offset = this.currentIndex * this.itemTotalWidth;
          this.list.style.transform = `translateX(-${offset}px)`;
        },
        
        handleResize() {
          // Recalculate dimensions on resize
          this.calculateDimensions();
          
          const perPage = this.getPerPage();
          const maxIndex = Math.max(0, this.slideCount - perPage);
          
          if (this.currentIndex > maxIndex) {
            this.currentIndex = maxIndex;
          }
          
          this.updateCarousel();
        },
        
        scrollToSlide(slideIndex) {
          const perPage = this.getPerPage();
          
          // If all items fit on screen, don't scroll
          if (this.slideCount <= perPage) {
            this.currentIndex = 0;
            this.updateCarousel();
            return;
          }
          
          // Calculate maximum scroll position
          const maxScrollIndex = this.slideCount - perPage;
          
          // Scroll to show the selected slide
          this.currentIndex = Math.min(slideIndex, maxScrollIndex);
          
          this.updateCarousel();
        }
      };
    }
    
    // Variant carousels are initialized via Alpine.js x-data="variantCarousel()" in HTML
    
    // Sync variant carousel with main Splide gallery using variant IDs
    function syncWithMainGallery() {
      const splideList = document.querySelector('.splide__list');
      const variantCarousel = document.querySelector('.mp-product-variant-mpcarousel');
      
      console.log('[Variant Carousel] Init:', { 
        hasCarousel: !!variantCarousel, 
        hasSplide: !!splideList 
      });
      
      if (!variantCarousel) {
        console.warn('[Variant Carousel] No carousel found');
        return;
      }
      
      // Helper function to sync is-active class based on data-variant-id matching
      function syncActiveClassByVariantId(activeVariantId) {
        console.log('[Variant Carousel] syncActiveClassByVariantId:', activeVariantId);
        
        if (!activeVariantId) {
          console.warn('[Variant Carousel] No variant ID provided');
          return;
        }
        
        // Find all gallery slides and variant carousel slides
        const gallerySlides = splideList ? splideList.querySelectorAll('.splide__slide[data-variant-id]') : [];
        const variantSlides = variantCarousel.querySelectorAll('.mpcarousel__slide[data-variant-id]');
        
        console.log('[Variant Carousel] Found slides:', { 
          gallerySlides: gallerySlides.length, 
          variantSlides: variantSlides.length 
        });
        
        // Update gallery slides (if gallery exists)
        gallerySlides.forEach(slide => {
          const slideVariantId = slide.getAttribute('data-variant-id');
          if (slideVariantId === activeVariantId) {
            slide.classList.add('is-active');
            console.log('[Variant Carousel] Added is-active to gallery slide:', slideVariantId);
          } else {
            slide.classList.remove('is-active');
          }
        });
        
        // Update variant carousel slides (always run this)
        variantSlides.forEach(slide => {
          const slideVariantId = slide.getAttribute('data-variant-id');
          if (slideVariantId === activeVariantId) {
            slide.classList.add('is-active');
            console.log('[Variant Carousel] Added is-active to variant slide:', slideVariantId);
          } else {
            slide.classList.remove('is-active');
          }
        });
      }
      
      
      // Check URL for variant parameter
      const urlParams = new URLSearchParams(window.location.search);
      const urlVariantId = urlParams.get('variant');
      
      console.log('[Variant Carousel] URL variant:', urlVariantId);
      
      // Set initial is-active class based on URL variant or checked input
      let initialVariantId = null;
      
      if (urlVariantId) {
        // If URL has a variant, select it
        const urlVariantInput = variantCarousel.querySelector(`input[data-variant-id="${urlVariantId}"]`);
        console.log('[Variant Carousel] URL variant input found:', !!urlVariantInput);
        if (urlVariantInput) {
          urlVariantInput.checked = true;
          initialVariantId = urlVariantId;
          
          // Trigger Alpine change event
          urlVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      
      // If no URL variant or URL variant not found, use checked input
      if (!initialVariantId) {
        const checkedInput = variantCarousel.querySelector('input[type="radio"]:checked');
        console.log('[Variant Carousel] Checked input:', checkedInput);
        if (checkedInput) {
          initialVariantId = checkedInput.getAttribute('data-variant-id');
          console.log('[Variant Carousel] Using checked input variant:', initialVariantId);
        } else {
          // If nothing is checked, select the first available variant
          const firstAvailableInput = variantCarousel.querySelector('input[type="radio"]:not([disabled])');
          console.log('[Variant Carousel] First available input:', firstAvailableInput);
          if (firstAvailableInput) {
            firstAvailableInput.checked = true;
            initialVariantId = firstAvailableInput.getAttribute('data-variant-id');
            console.log('[Variant Carousel] Using first available variant:', initialVariantId);
            
            // Trigger Alpine change event
            firstAvailableInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
      
      // Apply is-active class
      console.log('[Variant Carousel] Applying initial is-active to:', initialVariantId);
      if (initialVariantId) {
        syncActiveClassByVariantId(initialVariantId);
      }
      
      // Add listeners to variant carousel slides for instant is-active class update
      const variantSlides = variantCarousel.querySelectorAll('.mpcarousel__slide[data-variant-id]');
      console.log('[Variant Carousel] Setting up listeners for', variantSlides.length, 'slides');
      
      variantSlides.forEach(slide => {
        // On mousedown/touchstart - instant feedback before click registers
        slide.addEventListener('mousedown', (e) => {
          const variantId = slide.getAttribute('data-variant-id');
          console.log('[Variant Carousel] Mousedown on slide:', variantId);
          if (variantId) {
            syncActiveClassByVariantId(variantId);
          }
        });
        
        slide.addEventListener('touchstart', (e) => {
          const variantId = slide.getAttribute('data-variant-id');
          console.log('[Variant Carousel] Touchstart on slide:', variantId);
          if (variantId) {
            syncActiveClassByVariantId(variantId);
          }
        }, { passive: true });
        
        // Also add listener to the radio input inside for when it changes
        const input = slide.querySelector('input[type="radio"][data-variant-id]');
        if (input) {
          console.log('[Variant Carousel] Found input in slide:', input.getAttribute('data-variant-id'));
          input.addEventListener('change', (e) => {
            const variantId = e.target.getAttribute('data-variant-id');
            console.log('[Variant Carousel] Input change:', variantId);
            if (variantId) {
              syncActiveClassByVariantId(variantId);
            }
          });
        } else {
          console.warn('[Variant Carousel] No input found in slide:', slide);
        }
      });
      
      // If no Splide gallery, still handle radio input changes for is-active class
      if (!splideList) {
        const variantInputs = variantCarousel.querySelectorAll('input[type="radio"][data-variant-id]');
        variantInputs.forEach(input => {
          input.addEventListener('change', (e) => {
            const variantId = e.target.getAttribute('data-variant-id');
            if (variantId) {
              syncActiveClassByVariantId(variantId);
            }
          });
        });
        return; // Exit early if no gallery to sync with
      }
      
      // Wait for Splide to be initialized before setting up sync
      const checkSplide = setInterval(() => {
        const splideElement = splideList.closest('.splide');
        if (window.Splide && splideElement && splideElement.splide) {
          clearInterval(checkSplide);
          
          const splide = splideElement.splide;
          
          // GALLERY → VARIANT: When gallery slide changes, sync is-active class
          splide.on('moved', (newIndex) => {
            // Get the active slide
            const activeSlide = splide.Components.Slides.getAt(newIndex);
            if (activeSlide) {
              const variantId = activeSlide.slide.getAttribute('data-variant-id');
              
              if (variantId) {
                // Sync is-active class based on matching data-variant-id
                syncActiveClassByVariantId(variantId);
                
                // Find and select the matching variant input to trigger product change
                const variantInput = variantCarousel.querySelector(`input[data-variant-id="${variantId}"]`);
                
                if (variantInput && !variantInput.checked) {
                  // Check the radio input
                  variantInput.checked = true;
                  
                  // Dispatch change event to trigger Alpine.js
                  const changeEvent = new Event('change', { bubbles: true });
                  variantInput.dispatchEvent(changeEvent);
                  
                  // Scroll variant carousel to show the selected variant
                  const carouselInstance = variantCarousel.variantCarouselInstance;
                  if (carouselInstance && typeof carouselInstance.scrollToSlide === 'function') {
                    setTimeout(() => {
                      const allInputs = Array.from(variantCarousel.querySelectorAll('input[type="radio"]'));
                      const slideIndex = allInputs.indexOf(variantInput);
                      if (slideIndex >= 0) {
                        carouselInstance.scrollToSlide(slideIndex);
                      }
                    }, 50);
                  }
                }
              }
            }
          });
          
          // VARIANT → GALLERY: When variant is clicked, sync is-active class and move gallery
          const variantInputs = variantCarousel.querySelectorAll('input[type="radio"][data-variant-id]');
          
          variantInputs.forEach(input => {
            input.addEventListener('change', (e) => {
              const variantId = e.target.getAttribute('data-variant-id');
              if (!variantId) return;
              
              // Sync is-active class based on matching data-variant-id
              syncActiveClassByVariantId(variantId);
              
              // Find gallery slide with matching variant ID and move to it
              const allSlides = splide.Components.Slides.get();
              const matchingSlideIndex = allSlides.findIndex(slide => {
                return slide.slide.getAttribute('data-variant-id') === variantId;
              });
              
              if (matchingSlideIndex >= 0) {
                // Move gallery to that slide
                splide.go(matchingSlideIndex);
              }
            });
          });
        }
      }, 100);
      
      // Clear interval after 5 seconds to avoid infinite loop
      setTimeout(() => clearInterval(checkSplide), 5000);
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        syncWithMainGallery();
      });
    } else {
      syncWithMainGallery();
    }
    
})();

// Keep price/weight block and first app block in one flow row.
// Defined outside the main carousel IIFE to avoid mixing concerns.
function syncPriceAndAppRow(scope = document) {
  const blockAreas = scope.querySelectorAll('.product-block-area');
  blockAreas.forEach((area) => {
    const priceContainer = area.querySelector('.product-price-weight-container');
    if (!priceContainer) return;

    if (priceContainer.parentElement && priceContainer.parentElement.classList.contains('mp-price-app-inline-row')) {
      return;
    }

    let sibling = priceContainer.nextElementSibling;
    let appBlock = null;
    while (sibling) {
      if (sibling.classList.contains('app-block')) {
        appBlock = sibling;
        break;
      }
      sibling = sibling.nextElementSibling;
    }

    if (!appBlock) return;

    const row = document.createElement('div');
    row.className = 'mp-price-app-inline-row';
    priceContainer.parentNode.insertBefore(row, priceContainer);
    row.appendChild(priceContainer);
    row.appendChild(appBlock);
  });
}

function observePriceAndAppRow() {
  const areas = document.querySelectorAll('.product-block-area');
  areas.forEach((area) => {
    if (area.dataset.priceAppObserverBound === 'true') return;
    area.dataset.priceAppObserverBound = 'true';

    const observer = new MutationObserver(() => {
      syncPriceAndAppRow(area);
    });

    observer.observe(area, {
      childList: true,
      subtree: false
    });
  });
}

function initPriceAndAppRowSync() {
  syncPriceAndAppRow();
  observePriceAndAppRow();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPriceAndAppRowSync);
} else {
  initPriceAndAppRowSync();
}